import React, { FC, RefObject, useEffect, useState } from 'react'
import { Direction } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { classes } from './__index.utils'
import { CheckboxList, RadioList } from '@utils/request'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import * as utilsList from './__index.utils'
import * as formUtils from '@pages/auth/__index.utils'
import {
	PHONE_NUMBER_REGEX,
	POSTAL_CODE_REGEX
} from '@pages/auth/profile/__index.utils'
import MaskedThousandsSeparatorInput from '../inputs/textWithThousandsSeparator.inputs'
import TextAreaInput from '../inputs/textarea.inputs'
import DateFilterInput from '../inputs/datefilter.input'
import { joinClasses } from '@utils/styles'
import CheckboxInput from '../inputs/checkbox.input'

const Step6Branchement = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,
		requestAs,

		// **********************
		//*********** */
		isWaterAndSewerConnectionRequired,
		isPropertyConnectedToMunicipalConduits,
		additionalInfoQ42,
		plannedWork,
		entrepreneurUnknown,
		entrepreneurName,
		entrepreneurRBQNumber,
		entrepreneurRepresentativeName,
		entrepreneurRepresentativePhoneNumber,
		entrepreneurRepresentativeEmail,
		entrepreneurRepresentativeAddress,
		entrepreneurRepresentativeCity,
		entrepreneurRepresentativePostalCode,
		additionalInfoQ44
	} = formInputs

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const radioListWhoWillBeInChargeOfWork: RadioList[] =
		utilsList.radioListWhoWillBeInChargeOfWork(pageAssets)

	const listPlannedWork: CheckboxList[] = pageUtils.listPlannedWork(pageAssets)

	const radioListIsPropertyConnectedToMunicipalConduits: CheckboxList[] =
		pageUtils.radioListIsPropertyConnectedToMunicipalConduits(pageAssets)

	const getLabelFromList = (list, value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	const isEntrepreneurFieldsRequired = (value) => {
		return [
			listPlannedWork[0].value,
			listPlannedWork[1].value,
			listPlannedWork[2].value,
			listPlannedWork[5].value,
			listPlannedWork[6].value
		].some((option) => value?.toString()?.includes(option))
	}

	const [disabledMunicipalConduits, setDisabledMunicipalConduits] = useState<
		string[]
	>([])

	useEffect(() => {
		if (isWaterAndSewerConnectionRequired.value == 'false') {
			setDisabledMunicipalConduits([])
			return
		}

		const newValue = isPropertyConnectedToMunicipalConduits.value
		// Disable the value of the radio button that is not selected
		if (
			radioListIsPropertyConnectedToMunicipalConduits.slice(-1)[0].value !==
			newValue
		) {
			setDisabledMunicipalConduits([
				radioListIsPropertyConnectedToMunicipalConduits.slice(-1)[0].value
			])
		}
		// Disable the value of the radio button that is selected
		if (
			radioListIsPropertyConnectedToMunicipalConduits.slice(-1)[0].value ==
			newValue
		) {
			setDisabledMunicipalConduits(
				radioListIsPropertyConnectedToMunicipalConduits
					.slice(0, 4)
					.map((item) => item.value)
			)
		}
		// Enable the value of the radio button if the value is empty
		if (newValue == '') {
			setDisabledMunicipalConduits([])
		}
	}, [
		isPropertyConnectedToMunicipalConduits,
		isWaterAndSewerConnectionRequired
	])

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_branching_aqueduc_egouts}
				</h4>
			)}

			<RadioInput
				name={isWaterAndSewerConnectionRequired.name}
				label={isWaterAndSewerConnectionRequired.label}
				value={isWaterAndSewerConnectionRequired.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors.includes(isWaterAndSewerConnectionRequired.name)}
				required={isWaterAndSewerConnectionRequired.required}
				ref={
					isWaterAndSewerConnectionRequired.ref as RefObject<HTMLInputElement>
				}
				hasBackgroundWrapper={true}
				onChange={(value) =>
					updateInput(isWaterAndSewerConnectionRequired.name, value)
				}
				classWrapper={classes.reducedMarginBottom}
				isSummaryStep={isSummaryStep}
			/>

			{isWaterAndSewerConnectionRequired?.value?.toString() ==
				radioListYesNo[0].value && (
				<>
					<CheckboxInput
						name={isPropertyConnectedToMunicipalConduits.name}
						label={isPropertyConnectedToMunicipalConduits.label}
						description={isPropertyConnectedToMunicipalConduits.description}
						value={`${isPropertyConnectedToMunicipalConduits.value}`}
						list={radioListIsPropertyConnectedToMunicipalConduits}
						onChange={(value) =>
							updateCheckBoxInput(isPropertyConnectedToMunicipalConduits, value)
						}
						required={isPropertyConnectedToMunicipalConduits.required}
						hasError={errors.includes(
							isPropertyConnectedToMunicipalConduits.name
						)}
						ref={
							isPropertyConnectedToMunicipalConduits.ref as RefObject<HTMLInputElement>
						}
						errors={errors}
						shouldNotDivide
						hasBackgroundWrapper
						onFixError={onFixError}
						newCheckValue
						disabledValues={disabledMunicipalConduits}
						isSummaryStep={isSummaryStep}
					/>

					<TextAreaInput
						id={additionalInfoQ42.name}
						label={additionalInfoQ42.label}
						value={additionalInfoQ42.value}
						onChange={(value) => updateInput(additionalInfoQ42.name, value)}
						hasError={errors.includes(additionalInfoQ42.name)}
						required={additionalInfoQ42.required}
						ref={additionalInfoQ42.ref as RefObject<HTMLTextAreaElement>}
						maxCharacters={500}
						rows={4}
						isSummaryStep={isSummaryStep}
					/>

					<CheckboxInput
						name={plannedWork.name}
						label={plannedWork.label}
						description={plannedWork.description}
						value={`${plannedWork.value}`}
						list={listPlannedWork}
						onChange={(value) => updateCheckBoxInput(plannedWork, value)}
						required={plannedWork.required}
						hasError={errors.includes(plannedWork.name)}
						ref={plannedWork.ref as RefObject<HTMLInputElement>}
						errors={errors}
						shouldNotDivide
						hasBackgroundWrapper
						onFixError={onFixError}
						newCheckValue
						isSummaryStep={isSummaryStep}
					/>

					{plannedWork.value.includes(listPlannedWork.slice(-1)[0].value) && (
						<TextAreaInput
							id={additionalInfoQ44.name}
							label={additionalInfoQ44.label}
							value={additionalInfoQ44.value}
							onChange={(value) => updateInput(additionalInfoQ44.name, value)}
							hasError={errors.includes(additionalInfoQ44.name)}
							required={additionalInfoQ44.required}
							ref={additionalInfoQ44.ref as RefObject<HTMLTextAreaElement>}
							maxCharacters={500}
							rows={4}
							isSummaryStep={isSummaryStep}
						/>
					)}

					{isEntrepreneurFieldsRequired(plannedWork.value) && (
						<>
							{/* Entrepreneur (branchement d'aqueduc et d'égout ou génie civil) */}
							<h5 className={pageUtils.classes.h5}>
								{
									pageAssets?.request_form_buildingConstructionOrAdditionPermit_entrepreneur_branchement_aqueduc_egouts_ou_ingenieur_civil
								}
							</h5>

							{isSummaryStep && (
								<>
									<div>
										<strong>{entrepreneurUnknown.label}</strong>
										<br />
										<span
											className={joinClasses([
												pageUtils.classes.answerURB,
												'answerURB'
											])}
										>
											{getLabelFromList(
												radioListYesNo,
												entrepreneurUnknown.value?.toString() || String(false)
											)}
										</span>
									</div>
								</>
							)}
							{!isSummaryStep && (
								<>
									<div className={classes.checkbox2Container}>
										<span
											className={classes.checkboxWrapper}
											style={{ marginTop: '10px' }}
										>
											<input
												onChange={(e: any) =>
													updateInput(
														entrepreneurUnknown.name,
														e.target.checked
													)
												}
												value={entrepreneurUnknown.value?.toString()}
												className={classes.checkbox2}
												checked={entrepreneurUnknown.value.toString() == 'true'}
												type="checkbox"
												name={entrepreneurUnknown.name}
												id={entrepreneurUnknown.labelKey}
											/>
											<label
												className={classes.checkbox2Label}
												htmlFor={entrepreneurUnknown.labelKey}
											>
												{entrepreneurUnknown.label}
											</label>
										</span>
									</div>
								</>
							)}

							<TextInput
								id={entrepreneurName.name}
								label={entrepreneurName.label}
								value={entrepreneurName.value}
								onChange={(value) => updateInput(entrepreneurName.name, value)}
								hasError={errors.includes(entrepreneurName.name)}
								required={entrepreneurName.required}
								ref={entrepreneurName.ref as RefObject<HTMLInputElement>}
								maxCharacters={50}
								isSummaryStep={isSummaryStep}
							/>

							<MaskedTextInput
								id={entrepreneurRBQNumber.name}
								label={entrepreneurRBQNumber.label}
								value={entrepreneurRBQNumber.value}
								onChange={(value) =>
									updateInput(entrepreneurRBQNumber.name, value)
								}
								hasError={errors.includes(entrepreneurRBQNumber.name)}
								required={entrepreneurRBQNumber.required}
								ref={entrepreneurRBQNumber.ref as RefObject<HTMLInputElement>}
								max={12}
								min={12}
								mask="0000-0000-00"
								placeholder="1111-1111-11"
								errors={errors}
								setError={onFixError}
								schema={/^\d{4}-\d{4}-\d{2}$/}
								isSummaryStep={isSummaryStep}
							/>

							{/* Représentant(e) ou personne contact. */}
							{(!isSummaryStep ||
								(isSummaryStep &&
									(entrepreneurRepresentativeName.value ||
										entrepreneurRepresentativePhoneNumber.value ||
										entrepreneurRepresentativeEmail.value))) && (
								<h6
									className={pageUtils.classes.h6}
									style={{ marginTop: '20px' }}
								>
									{
										pageAssets?.request_form_buildingConstructionOrAdditionPermit_representative_or_contact_person
									}
								</h6>
							)}

							<TextInput
								id={entrepreneurRepresentativeName.name}
								label={entrepreneurRepresentativeName.label}
								value={entrepreneurRepresentativeName.value}
								onChange={(value) =>
									updateInput(entrepreneurRepresentativeName.name, value)
								}
								hasError={errors.includes(entrepreneurRepresentativeName.name)}
								required={entrepreneurRepresentativeName.required}
								ref={
									entrepreneurRepresentativeName.ref as RefObject<HTMLInputElement>
								}
								maxCharacters={50}
								isSummaryStep={isSummaryStep}
							/>

							<div
								className={joinClasses([
									pageUtils.classes.fieldsContainer,
									'fieldsContainer'
								])}
							>
								<MaskedTextInput
									id={entrepreneurRepresentativePhoneNumber.name}
									label={entrepreneurRepresentativePhoneNumber.label}
									value={entrepreneurRepresentativePhoneNumber.value}
									onChange={(value) =>
										updateInput(
											entrepreneurRepresentativePhoneNumber.name,
											value
										)
									}
									hasError={errors?.includes(
										entrepreneurRepresentativePhoneNumber.name
									)}
									type="tel"
									min={10}
									max={14}
									mask={formUtils.MASKS.phoneNumber}
									placeholder={formUtils.MASKS.phoneNumber}
									errors={errors ? errors : []}
									setError={onFixError}
									schema={PHONE_NUMBER_REGEX}
									required={entrepreneurRepresentativePhoneNumber.required}
									ref={
										entrepreneurRepresentativePhoneNumber.ref as RefObject<HTMLInputElement>
									}
									isSummaryStep={isSummaryStep}
								/>

								<TextInput
									id={entrepreneurRepresentativeEmail.name}
									label={entrepreneurRepresentativeEmail.label}
									value={entrepreneurRepresentativeEmail.value}
									onChange={(value) =>
										updateInput(entrepreneurRepresentativeEmail.name, value)
									}
									hasError={errors.includes(
										entrepreneurRepresentativeEmail.name
									)}
									required={entrepreneurRepresentativeEmail.required}
									ref={
										entrepreneurRepresentativeEmail.ref as RefObject<HTMLInputElement>
									}
									schema={formUtils.MASKS.email}
									schemaErrorText={pageAssets.label_emailErrorText}
									maxCharacters={50}
									type="email"
									onSetError={onFixError}
									isSummaryStep={isSummaryStep}
								/>
							</div>

							{/* Adresse de l'entreprise */}
							{(!isSummaryStep ||
								(isSummaryStep &&
									(entrepreneurRepresentativeAddress.value ||
										entrepreneurRepresentativeCity.value ||
										entrepreneurRepresentativePostalCode.value))) && (
								<h6
									className={pageUtils.classes.h6}
									style={{ marginTop: '20px' }}
								>
									{
										pageAssets?.request_form_buildingConstructionOrAdditionPermit_company_address
									}
								</h6>
							)}

							<TextInput
								id={entrepreneurRepresentativeAddress.name}
								label={entrepreneurRepresentativeAddress.label}
								value={entrepreneurRepresentativeAddress.value}
								onChange={(value) =>
									updateInput(entrepreneurRepresentativeAddress.name, value)
								}
								hasError={errors.includes(
									entrepreneurRepresentativeAddress.name
								)}
								required={entrepreneurRepresentativeAddress.required}
								ref={
									entrepreneurRepresentativeAddress.ref as RefObject<HTMLInputElement>
								}
								maxCharacters={50}
								isSummaryStep={isSummaryStep}
							/>

							<div
								className={joinClasses([
									pageUtils.classes.fieldsContainer,
									'fieldsContainer'
								])}
							>
								<TextInput
									id={entrepreneurRepresentativeCity.name}
									label={entrepreneurRepresentativeCity.label}
									value={entrepreneurRepresentativeCity.value}
									onChange={(value) =>
										updateInput(entrepreneurRepresentativeCity.name, value)
									}
									hasError={errors.includes(
										entrepreneurRepresentativeCity.name
									)}
									required={entrepreneurRepresentativeCity.required}
									ref={
										entrepreneurRepresentativeCity.ref as RefObject<HTMLInputElement>
									}
									maxCharacters={50}
									isSummaryStep={isSummaryStep}
								/>

								<MaskedTextInput
									id={entrepreneurRepresentativePostalCode.name}
									label={entrepreneurRepresentativePostalCode.label}
									value={entrepreneurRepresentativePostalCode.value}
									onChange={(value) =>
										updateInput(
											entrepreneurRepresentativePostalCode.name,
											value.toUpperCase()
										)
									}
									hasError={errors.includes(
										entrepreneurRepresentativePostalCode.name
									)}
									required={entrepreneurRepresentativePostalCode.required}
									ref={
										entrepreneurRepresentativePostalCode.ref as RefObject<HTMLInputElement>
									}
									max={7}
									min={7}
									mask={formUtils.MASKS.postalCode}
									placeholder="A1A 1A1"
									errors={errors}
									setError={onFixError}
									schema={POSTAL_CODE_REGEX}
									isSummaryStep={isSummaryStep}
								/>
							</div>
						</>
					)}
				</>
			)}
		</>
	)
}

export default Step6Branchement
